import { type ToastOptions, toast } from 'react-toastify'

export const toastError = (message: string, options?: ToastOptions) => {
	toast.error(message, options)
}
